import { useNavigate } from "react-router-dom";

import { MainLayout } from "~/layout";
import { ROUTES } from "~/router/routes";
import { ArrowIcon } from "~/shared/components/icons/ArrowIcon";
import { ClockIcon } from "~/shared/components/icons/ClockIcon";
import { FormContentContainer } from "../components/SignUp/FormContentContainer";

export const PendingEligibilityCheckScreen = () => {
  const navigate = useNavigate();

  return (
    <MainLayout>
      <FormContentContainer className="rounded-lg shadow-xl">
        <ClockIcon className="mb-4 size-16 self-center" />
        <div className="flex flex-col items-center text-center">
          <h1 className="font-display mb-2 text-xl">
            We're working on verifying your insurance.
          </h1>
          <p className="mb-12 text-gray-600">
            No worries! You can go ahead and schedule your appointment. We’ll
            send you an email as soon as we have the details confirmed.
          </p>
          <button
            className="flex cursor-pointer items-center justify-end gap-2 rounded-xl bg-green-300 px-6 py-4 font-medium"
            onClick={() => {
              navigate(ROUTES.providerSelection);
            }}
          >
            <span>NEXT</span>
            <ArrowIcon direction="left" />
          </button>
        </div>
      </FormContentContainer>
    </MainLayout>
  );
};
